import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Navbar from "components/ui/NavBar";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, mfaEnrolled } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <i className="fa-solid fa-spinner animate-spin"></i>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // A real session, but two-factor enrolment isn't finished. The backend
  // answers MFA_REQUIRED on every guarded route anyway — this just puts them
  // on the page that can resolve it instead of on an empty screen.
  if (!mfaEnrolled) {
    return <Navigate to="/mfa-setup" replace />;
  }

  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

export default ProtectedRoute;
